import React from 'react';
import styled from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockSermon } from '../../blocks/BlockSermon';
import { BlockCollage } from '../../blocks/BlockCollage';
import { BlockInfo, blockInfoHasContent } from '../../blocks/BlockInfo';
import { SpacerTop } from '../../sectionLayouts/Spacers';
import { SermonBlockLayoutProps } from './SermonLayout';
import { BlockLayoutProps } from '../../types/component';
import { css } from 'styled-components';

export const SermonBlockLayoutCollage = (props: SermonBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);

  const renderInfo = blockInfoHasContent(props.blocks[0]);

  return (
    <StyledBlockLayout {...props} renderInfo={renderInfo}>
      <StyledBlockCollage {...innerProps} block={props.blocks[0]} />
      {renderInfo && <StyledBlockInfo {...innerProps} block={props.blocks[0]} />}
      <StyledBlockSermon {...innerProps} block={props.blocks[0]} />
    </StyledBlockLayout>
  );
};

const SermonHeightMap = {
  small: 1,
  medium: 2,
  large: 3,
};

const getSermonPadding = (props: BlockLayoutProps) => {
  const defaultHeight = 'small';
  const multiplier = SermonHeightMap[props.height ?? defaultHeight];

  return css`
    padding: calc(var(--unit-length) * ${multiplier}) var(--unit-length);
  `;
};

const StyledBlockSermon = styled(BlockSermon)``;
const StyledBlockCollage = styled(BlockCollage)``;
const StyledBlockInfo = styled(BlockInfo)``;

const StyledBlockLayout = styled(BlockLayout)<{
  renderInfo: boolean;
}>`
  ${StyledBlockInfo} {
    ${SpacerTop} {
      display: none;
    }
  }

  ${StyledBlockInfo} {
    min-height: ${(props) => {
      switch (props.height) {
        case 'medium':
          return '40vh';
        case 'large':
          return '55vh';
        default:
          return undefined;
      }
    }};
  }

  ${StyledBlockSermon} {
    ${getSermonPadding}
    padding-top: ${(props) => (props.renderInfo ? '0' : undefined)};
  }
`;
